import React, { PureComponent } from 'react'

class ResultsFilterbar extends PureComponent {

  render() {
    return (
      <div className="filter-premium">
        <p className="filter-premium__label">
          Sortiert nach:
        </p>
        <label className="filter-premium__switch" >
          <input type="checkbox" className="filter-premium__checkbox" value={this.props.premiumOn} onChange={value => this.props.setFiltersData(value, 'premiumFilter')} />
          <span className={!this.props.premiumOn ? 'filter-premium__leftside active' : 'filter-premium__leftside'} >
            Datum &uarr;
          </span>
          <span className={this.props.premiumOn ? 'filter-premium__rightside active' : 'filter-premium__rightside'} >
            Premium-Events
          </span>
        </label>


      </div>
    )
  }
}

export default ResultsFilterbar


// WEBPACK FOOTER //
// ./src/components/parts/ResultsFilterbar.js